import { FETCH_SAP_MONTHLY_DATA, QUERY_SAP_MONTHLY_DATA, GENERATE_EXCEL } from 'actions/sap';

const initialState = {
  isLoading: false,
  sapMonthlyData: [],
  sapMonthlyDataForDownload: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const sapMonthlyData = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_SAP_MONTHLY_DATA.REQUEST:
    case QUERY_SAP_MONTHLY_DATA.REQUEST:
    case GENERATE_EXCEL.REQUEST:
      {
        return { ...state, isLoading: true };
      }
    case FETCH_SAP_MONTHLY_DATA.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        sapMonthlyData: payload.data,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }
    case QUERY_SAP_MONTHLY_DATA.SUCCESS:
    case GENERATE_EXCEL.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        sapMonthlyDataForDownload: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case FETCH_SAP_MONTHLY_DATA.FAIL:
    case QUERY_SAP_MONTHLY_DATA.FAIL:
    case GENERATE_EXCEL.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default sapMonthlyData;
